import client from "../../client/client";

class NotesService {
	create({ projectId }, { value }, cancelToken) {
		return client.post(`/notes/projects/${projectId}`, { payload: { value }, config: { cancelToken } });
	}

	createAI({ projectId }, cancelToken) {
		return client.post(`/notes/projects/${projectId}/launch-ai`, { config: { cancelToken } });
	}

	checkIfTitleExists({ projectId }, { title }, cancelToken) {
		return client.get(`/notes/projects/${projectId}/exist`, { params: { title }, config: { cancelToken } });
	}

	saveNoteAgentConfig(
		{ projectId },
		{ integrationPolicy, documents, additionPrompt, selectDocumentAutomatically },
		cancelToken
	) {
		return client.post(`/notes/projects/${projectId}/ai-config`, {
			payload: {
				integrationPolicy,
				documents,
				additionPrompt,
				selectDocumentAutomatically,
			},
			config: { cancelToken },
		});
	}

	getNoteAgentConfig({ projectId }, cancelToken) {
		return client.get(`/notes/projects/${projectId}/ai-config`, { config: { cancelToken } });
	}

	getAllNotes({ projectId }, { page, limit, sort, dir }, { title, isGeneratedByAi }, cancelToken) {
		return client.post(`/notes/projects/${projectId}/search`, {
			params: { page, limit, sort, dir },
			payload: { title, isGeneratedByAi },
			config: { cancelToken },
		});
	}

	getNote({ noteId }, cancelToken) {
		return client.get(`/notes/${noteId}`, { config: { cancelToken } });
	}

	updateNote({ noteId }, { value }, cancelToken) {
		return client.post(`/notes/${noteId}`, { payload: { value }, config: { cancelToken } });
	}

	deleteNote({ noteId }, cancelToken) {
		return client.delete(`/notes/${noteId}`, { config: { cancelToken } });
	}

	duplicateNote({ noteId }, cancelToken) {
		return client.post(`/notes/${noteId}/duplicate`, { config: { cancelToken } });
	}

	renameNote({ noteId }, { value }, cancelToken) {
		return client.post(`/notes/${noteId}/title`, { payload: { value }, config: { cancelToken } });
	}

	updateNoteStatus({ noteId }, { status }, cancelToken) {
		return client.patch(`/notes/${noteId}/status`, { payload: status, config: { cancelToken } });
	}

	getNoteDetails({ noteId }, cancelToken) {
		return client.get(`/notes/${noteId}/details`, { config: { cancelToken } });
	}

	getIsGenerating({ projectId }, cancelToken) {
		return client.get(`/notes/projects/${projectId}/launch-ai`, { config: { cancelToken } });
	}

	getNoteSuggestions({ projectId }, cancelToken) {
		return client.get(`/notes/projects/${projectId}/suggestions`, { config: { cancelToken } });
	}
}

export default new NotesService();
